import { getFontSizeXD } from "../../utils";
import theme from "../../theme";

const styles = {
  root: {
    position: "absolute",
    top: theme.defaultMargin + 20,
    right: theme.defaultMargin,
    opacity: 0,
    zIndex: 90,
  },
  textStyle: {
    color: "white",
    fontFamily: "Montserrat, sans-serif",
    fontSize: getFontSizeXD(15),
    letterSpacing: 3.75,
    fontWeight: "bold",
  },
};

export default styles;
